import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {DomainDataResponse} from '../../api/types/project.type';

interface DomainDataState {
  data: DomainDataResponse | null;
}

const initialState: DomainDataState = {
  data: null,
};

export const domainDataSlice = createSlice({
  name: 'domainData',
  initialState,
  reducers: {
    setDomainData: (state, action: PayloadAction<DomainDataResponse>) => {
      state.data = action.payload;
    },
    clearDomainData: (state) => {
      state.data = null;
    },
  },
});

export const {setDomainData, clearDomainData} = domainDataSlice.actions;
export default domainDataSlice.reducer;
